import { KiwixiService } from './../../kiwixi/kiwixi.service';
import { Directive, Output, EventEmitter, HostListener, Input } from '@angular/core';
import { DownloadLingueoService } from './download-lingueo.service';

@Directive({
  selector: '[appDownloadLingueo]',
  providers: [DownloadLingueoService]
})
export class DownloadLingueoDirective {
  @Input() document;
  @Input() invoice;
  @Input() canUpdateDownloaded;
  @Input() isInvoice;
  @Input() templateVersion;
  @Output() updateDownloaded = new EventEmitter();

  constructor(private downloadLingueoService: DownloadLingueoService, private kiwixiService: KiwixiService) { }

  @HostListener('click', ['$event', '$event.target'])
  public onClick(event: MouseEvent, targetElement: HTMLElement): void {
    if (this.isInvoice) {
      const _url = this.invoice.url + 'download/';
      this.downloadLingueoService.downloadDoc(_url, this.invoice['filename'])
        .subscribe({
          next: (file: ArrayBuffer) => {
            this.kiwixiService.downloadFile(this.invoice.filename, file);
          },
          error: (error: any) => {
            this.kiwixiService.handleError(error.statusText).catch(_res => {
              console.error(`error downloadDoc invoice ` + this.invoice['filename'], error);
            })
          }
        });
    } else {
      this.downloadLingueoService.downloadDoc(this.document.download_url, this.document.name)
        .subscribe({
          next: (file: ArrayBuffer) => {
            this.kiwixiService.downloadFile(this.document.name, file);
          },
          error: (error: any) => {
            this.kiwixiService.handleError(error.statusText).catch(_res => {
              console.error(`error downloadDoc document ` + this.document.name, error);
            })
          }
        });
      if (this.updateDownloaded) {
        document['downloaded'] = true;
        this.updateDownloaded.emit(true);
      }
    }
  }
}
